import type { TraceErrorObject } from 'owa-analytics-types';
import type { UPSCollaborator } from 'places-ups-location-operations';
import { getPeopleInBuildingUpsFromService } from './getPeopleInBuildingFromService';

import type { CollaboratorSource } from 'hybridspace-common/lib/serviceTypes';

export function getPeopleInBuildingUps(category: CollaboratorSource): {
    resultedData: UPSCollaborator[];
    loading: boolean;
    error: TraceErrorObject | undefined;
} {
    return getPeopleInBuildingUpsFromService(category);
}
